export const preventBodyScroll = yes => {
  if (yes) {
    $("body").addClass("stopScroll");
  }
  if (!yes) {
    $("body").removeClass("stopScroll");
  }
};

export const toggleBodyScroll = () => {
  $("body").toggleClass("stopScroll");
};

